import { Routes } from '@angular/router';

import { flightResultsRootRoute } from '@flight-results/flight-results-routing.constants';
import { flightExchangeRootRoute } from '@flight-results/flight-exchanges-routing.module';
import { flightsRootRoute } from '@flights/flights-routing.module';
import { ModuleCountryGuard } from '@app/services/guard/module-country.guard';
import { FLIGHT } from '@app/constants/route-titles.constants';
import { HeaderType } from '@design-system/components/templates/header/entities/header.types';
import { HeaderPageType, HeaderProductType } from '@header/entities/ds-header-config';
import { RoutingLevel } from '@ux/animations/animations';

export const flightsAllModuleRoutes: Routes = [
  {
    path: flightsRootRoute, loadChildren: () =>
      import('../modules/flights/flights.module').then(m => m.FlightsModule),
    data: {
      routingLevel: RoutingLevel.Two,
      dsHeaderConfig: {
        type: HeaderType.Generic,
        titleKey: FLIGHT,
        pageType: HeaderPageType.SearchPage,
      },
    },
    canActivate: [ModuleCountryGuard]
  },
  {
    path: flightResultsRootRoute, loadChildren: () =>
      import('../modules/flight-results/flight-results.module').then(m => m.FlightResultsModule),
    data: {
      routingLevel: RoutingLevel.Six,
      dsHeaderConfig: {
        type: HeaderType.Results,
        titleKey: null,
        pageType: HeaderPageType.ResultsPage,
        productType: HeaderProductType.Air,
      },
    },
    canActivate: [ModuleCountryGuard]
  },
  {
    path: flightExchangeRootRoute, loadChildren: () =>
      import('../modules/flight-results/flight-exchange.module').then(m => m.FlightExchangeModule),
    data: {
      routingLevel: RoutingLevel.Six,
      dsHeaderConfig: {
        type: HeaderType.Results,
        titleKey: null,
        pageType: HeaderPageType.ResultsPage,
        productType: HeaderProductType.Exchanges,
      },
    },
    canActivate: [ModuleCountryGuard]
  },
];
